import { FileReader, FileWriter } from '@/platform'

class FileItem {
    public name: string = '' // 文件名（相对路径）
    public length: number = 0 // 文件大小（字节）
    public point: number = 0 // 在整个流里的位置

    constructor(name: string = '', l: number = 0, p: number = 0) {
        this.name = name
        this.length = l
        this.point = p
    }

    readBin(reader: FileReader): void {
        this.name = reader.readString()
        this.length = reader.readLong()
        this.point = reader.readLong()
    }

    writeBin(writer: FileWriter): void {
        writer.writeString(this.name)
        writer.writeInt64(this.length)
        writer.writeInt64(this.point)
    }

    readVersionedOui(reader: FileReader): void {
        this.name = reader.readString()
        this.length = reader.readLong()
        this.point = reader.readLong()
    }

    writeVersionedOui(writer: FileWriter): void {
        writer.writerIntLength()
        writer.writeString(this.name)
        writer.writeInt64(this.length)
        writer.writeInt64(this.point)
        writer.writerLength()
    }
}

export default FileItem
